import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface ITag {
  id: string;
  name: string;
  description?: string;
}

export interface Tag {
  id: number;
  name: string;
  description?: string;
  scenarios: unknown[];
}

export const tagApi = createApi({
  reducerPath: 'tagApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Tags'],
  endpoints: (builder) => ({
    getTagByName: builder.query<Tag, string>({
      query: (tagName) => ({
        url: `/tags/${tagName}`,
        method: 'GET'
      })
    }),
  }),
});

export const { useGetTagByNameQuery, useLazyGetTagByNameQuery } = tagApi;
